/* npm modules outside of vrbo */
import React, {useEffect, useState} from 'react';
import {PropTypes} from 'prop-types';

/* Atoms (baseline) */
import {ButtonPrimary} from '../../atoms/baseline/baseline';

/* Molecules (baseline) */
import {Alert, InputTokenize, Modal} from '../baseline/baseline';

import {useEntryModal} from '../../context/EntryModalContext';

export const AddGuestsModal = ({
    buttonLabel,
    handleClose,
    handleRecipientsChange,
    isValidEmail,
    label,
    modalSubTitle,
    modalTitle,
    onSubmit,
    removeLabel,
    state,
}) => {
    const {disableSend, errorMsg, isLoading, isOpen, recipients} = state;
    const [isEntryModalOpen] = useEntryModal();
    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        setHasMounted(true);
    }, []);

    if (!hasMounted) {
        return null;
    }

    return (
        <Modal
            footer={
                <ButtonPrimary
                    className={'btn-block-xs'}
                    disabled={disableSend}
                    label={buttonLabel}
                    onClick={onSubmit}
                />
            }
            id={'invite-guests-modal'}
            isLoading={isLoading}
            isOpen={isOpen && !isEntryModalOpen}
            onClose={handleClose}
            title={modalTitle}
        >
            {modalSubTitle && <p>{modalSubTitle}</p>}
            <form role="form" onSubmit={onSubmit}>
                {errorMsg && <Alert msg={errorMsg} />}
                <InputTokenize
                    isValid={isValidEmail}
                    label={label}
                    onChange={handleRecipientsChange}
                    removeLabel={removeLabel}
                    tokens={recipients}
                />
            </form>
        </Modal>
    );
};

AddGuestsModal.propTypes = {
    buttonLabel: PropTypes.string.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleRecipientsChange: PropTypes.func.isRequired,
    isValidEmail: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    modalTitle: PropTypes.string.isRequired,
    modalSubTitle: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    removeLabel: PropTypes.string,
    state: PropTypes.shape({
        disableSend: PropTypes.bool.isRequired,
        errorMsg: PropTypes.string.isRequired,
        isLoading: PropTypes.bool.isRequired,
        isOpen: PropTypes.bool,
        recipients: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
};
